// extracted by mini-css-extract-plugin
export default {"known-keys":"QueryRuleSchemaEditor_known-keys__xZQqH","knownKeys":"QueryRuleSchemaEditor_known-keys__xZQqH"};